<template>
    <div class="flex items-center justify-center text-theme-icon">
        <BaseButton
            v-if="canUseReader"
            :tooltip="ui.plugin.localizations.alt"
            :class="{ active: ui.plugin.opened }"
            :disabled="isOffline"
            icon="reader-plugin-ai"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.plugin.opened)"
            @click="togglePlugin"
        />

        <BaseButton
            v-if="canUseListening"
            :tooltip="localizations[lang].tooltips.listen"
            class="block"
            :class="{ active: listeningIsActive }"
            :disabled="isOffline"
            icon="baseline-headset-24px"
            width="24px"
            height="24px"
            @click="listeningPage"
        />

        <BaseButton
            v-if="canViewSetting"
            key="settings-button"
            :tooltip="localizations[lang].tooltips.config"
            class="block md:relative"
            dusk="toggleSettings"
            :class="{ active: ui.settings.opened }"
            icon="display-setting"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.settings.opened)"
            @click="toggleSettings"
        />

        <div class="relative">
            <BaseButton
                v-if="canUseSearch"
                :tooltip="localizations[lang].tooltips.search"
                dusk="toggleSearch"
                :disabled="isOffline"
                icon="magnifying-glass"
                width="24px"
                height="24px"
                :aria-expanded="String(ui.search.opened)"
                @click="toggleSearch"
            />
            <MenuSearch />
        </div>

        <BaseButton
            v-if="canViewNotebooks"
            key="notebook-button-mobile"
            :tooltip="localizations[lang].notebook"
            :class="{ active: ui.notebook.opened }"
            :disabled="isOffline"
            icon="outline-description-24px"
            icon-class="text-blue-500"
            width="24px"
            height="24px"
            :aria-expanded="String(ui.notebook.opened)"
            @click="toggleNotebook"
        />
        <MenuMore
            v-if="!isOpenFullViewContentModal"
            :is-menu-visible="ui.rightSubmenu.opened"
            @toggle="toggleRightSubmenu"
        />
    </div>
</template>

<script>
'use strict';
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseButton from '../Components/buttons/BaseButton.vue';
import MenuMore from '../Components/MenuMore.vue';
import MenuSearch from '../Components/MenuSearch.vue';

export default {
    components: {
        MenuMore,
        BaseButton,
        MenuSearch,
    },
    computed: {
        ...mapState(['ui', 'reader', 'isOffline', 'localizations', 'lang']),
        ...mapGetters(['onlyDesktopVisible', 'onlyMobileVisible', 'canUseReaderPlugins']),
        listeningIsActive() {
            return this.ui.listening.opened && this.ui.listening.texToListen === this.ui.listening.pageToListen;
        },
        canUseReader() {
            return this.canUseReaderPlugins && !this.isOpenFullViewContentModal;
        },
        canUseListening() {
            return (
                this.onlyDesktopVisible &&
                this.ui.listening.enabled &&
                this.ui.listening.pageToListen &&
                !this.isOpenFullViewContentModal
            );
        },
        canViewSetting() {
            return this.onlyDesktopVisible && !this.isOpenFullViewContentModal;
        },
        canUseSearch() {
            return this.ui.search.enabled && !this.isOpenFullViewContentModal;
        },
        canViewNotebooks() {
            return this.onlyMobileVisible && !this.isOpenFullViewContentModal;
        },
        isOpenFullViewContentModal() {
            if (!this.onlyMobileVisible) {
                return false;
            }
            return (
                this.ui.notebook.opened ||
                this.ui.tableOfContents.opened ||
                this.ui.thumbnails.opened ||
                this.ui.search.opened
            );
        },
    },
    methods: {
        ...mapActions([
            'listeningPage',
            'toggleNotebook',
            'toggleSearch',
            'toggleSettings',
            'togglePlugin',
            'toggleRightSubmenu',
        ]),
    },
};
</script>
